import { Link } from "react-router-dom";

export const Monogram = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="6" y="12" width="9" height="40" fill="#0F2D4A" />
    <rect x="15" y="28" width="10" height="8" fill="#0F2D4A" />
    <rect x="25" y="12" width="9" height="40" fill="#0F2D4A" />
    <path d="M34 12h5a20 20 0 0 1 0 40h-5v-9h5a11 11 0 0 0 0-22h-5z" fill="#6E747B" />
    <path d="M9 49 C24 44 40 37 57 25" fill="none" stroke="#B3262D" strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

export const Wordmark = ({ light = false, className = "text-[22px] sm:text-[26px]" }) => (
  <span className={`brand-wordmark inline-flex items-baseline ${className}`}>
    <span className="relative inline-block font-bold" style={{ color: light ? "#FFFFFF" : "#0F2D4A" }}>
      Harrington's
      <span className="absolute inset-x-0 -bottom-[0.18em] h-[2px] bg-brand-underline" aria-hidden data-testid="logo-underline" />
    </span>
    <span className="ml-[0.28em] font-medium" style={{ color: light ? "#A7ADB4" : "#55595F" }}>Direct</span>
  </span>
);

export const Logo = ({ to = "/", light = false, tagline = true }) => (
  <Link to={to} className="inline-flex flex-col leading-none" data-testid="site-wordmark" aria-label="Harrington's Direct home">
    <Wordmark light={light} />
    {tagline && <span className={`mt-2.5 block self-end whitespace-nowrap text-[8.5px] font-semibold uppercase tracking-[0.12em] sm:text-[9.5px] sm:tracking-[0.2em] ${light ? "text-brand-silver" : "text-[#7B8189]"}`} data-testid="brand-tagline">Sell your car. Deal direct.</span>}
  </Link>
);
